<template>
  <div v-if="!isLoading">
    <StepTitle :session="session" hr class="text-center">
      <div>{{title}}</div>
      <template #subtitle>{{subtitle}}</template>
    </StepTitle>
    <div v-if="this.session && items.length">
      <section class="boxes select-item-table">
        <div class="index-content centered-block ">
          <b-col lg="12" cols="12" class="pl-sm-3 pr-sm-3 pl-0 pr-0">
            <div class="order-it">
              <b-table
                :items="itemData"
                :fields="itemDataFields"
                class="table-responsive d-table order-item-status-table"
                @row-clicked="onRowClicked"
              >
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template v-slot:head(select)="data">
                  <b-form-checkbox
                    v-model="allSelected"
                    :indeterminate="indeterminate"
                    @click.native.stop
                    @change="toggleAll"
                    class="check"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(product)="data">
                  <table class="inner-table">
                    <tr>
                      <td><img class="product-image order-pic " alt="" :src="data.item.image" /></td>
                      <td class="item-title">
                        <div>
                          <span class="product-quantity">{{data.item.quantity}} &times; </span>
                          <span v-html="data.item.name"></span>
                        </div>
                        <div class="price">
                          <span v-if="data.item.currentPrice < data.item.price" class="original-price">{{data.item.price | currency(data.item.currency)}} </span>
                          {{data.item.currentPrice | currency(data.item.currency)}}
                        </div>
                      </td>
                    </tr>
                  </table>
                </template>
                <template v-slot:cell(select)="data" class="title ">
                  <b-form-checkbox
                    :checked="isItemChecked(data.item)"
                    :disabled="!canToggleItem(data.item)"
                    @click.native.stop
                    @change="toggleItem(data.item, $event)"
                    class="check"
                  ></b-form-checkbox>
                </template>
                <template v-slot:cell(selectedQuantity)="data" class="active">
                  <b-form-select
                    :value="rmaQuantities[data.item.id]"
                    @input="changeQuantity(data.item, $event)"
                    :disabled="!canToggleItem(data.item)"
                  >
                    <option value="0">0</option>
                    <option v-for="i in data.item.quantity" :key="i" :value="i">{{i}}</option>
                  </b-form-select>
                </template>
              </b-table>
            </div>
          </b-col>
        </div>
      </section>
    </div>
    <div v-else>
      <div class="centered-block">
        <div class="step-title">No items found</div>
      </div>
    </div>
    <b-row class="justify-content-md-center boxes select-item-btn customer-verify">
      <b-col v-if="showBackButton" md="4" lg="3" cols="6" class="back">
        <button type="button" @click="goBack()" class="btn-base input-btn new-btn-outline-success stroke-2x">Back</button>
      </b-col>
      <b-col md="4" lg="3" cols="6">
        <button type="button" @click="done()" class="btn-base input-choice-btn font-weight-normal stroke-2x" :disabled="getSelectionCount() === 0">{{label}}
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { FulfillmentStatus, ProductType, ItemStatus, CancelItemsSelection, ProcessType } from '../constants'
import { getItemImageUrl } from '@/utils'
const StepTitle = () => import('./StepTitle')

export default {
  name: 'SelectActionItems',
  components: {StepTitle},
  props: {
    session: Object,
    input: Object,
    label: String,
    rebill: {
      type: Boolean,
      default: function() {
        return false
      }
    },
    defaults: {
      type: Object,
      default: function() {
        return {items: []}
      }
    }
  },
  data: function() {
    return {
      items: [],
      linkedItems: [],
      itemDataFields: [
        {key: 'select', label: '', tdClass: 'selectbox'},
        {key: 'product', label: 'Product'}
      ],
      allSelected: false,
      indeterminate: false,
      rmaQuantities: {},
      title: '',
      subtitle: '',
      isOnHold: false,
      allMainItemsSelected: false
    }
  },
  computed: {
    ...mapState(['selectedItems', 'startIndex', 'isLoading']),
    itemData: function() {
      let data = []

      for (let item of this.items) {
        if (!item) {
          continue
        }
        this.addItemToDataArray(data, item)

        if (this.session.selected_item && (item.id === this.session.selected_item.id)) {
          for (let linkedItem of this.linkedItems) {
            this.addItemToDataArray(data, linkedItem)
          }
        }
      }

      return data
    },
    showBackButton: function() {
      return this.session && (this.session.can_undo || this.session.is_step_preview)
    }
  },
  methods: {
    addItemToDataArray(data, item) {
      data.push({
        id: item.id,
        image: this.getImageUrl(item),
        name: this.getDisplayName(item),
        selectedQuantity: this.rmaQuantities[item.id],
        quantity: item.quantity,
        price: item.price,
        currentPrice: item.current_price,
        isAddOn: this.isAddonItem(item),
        currency: item.order.currency
      })
    },
    getVariantLabel(item) {
      let options = []
      let label = ''

      if (item.variant) {
        item.variant.options.forEach((option) => {
          options.push(option.name + ': ' + option.value)
        })

        label = options.join(', ')
      }

      return label
    },
    getDisplayName(item) {
      let name = item.name
      const variantLabel = this.getVariantLabel(item)

      if (variantLabel) {
        name += ' - ' + variantLabel
      }

      return name
    },
    done: function() {
      const selectionCount = this.getSelectionCount()

      if (selectionCount > 0) {
        let selectedItems = []
        let mainSelectedItem = null

        this.items.forEach(item => {
          if (this.rmaQuantities[item.id] > 0) {
            selectedItems.push({id: item.id, quantity: this.rmaQuantities[item.id]})

            if (!mainSelectedItem || this.isSessionItem(item)) {
              mainSelectedItem = item
            }
          }
        })

        this.linkedItems.forEach(item => {
          if (this.rmaQuantities[item.id] > 0) {
            selectedItems.push({id: item.id, quantity: this.rmaQuantities[item.id]})
            this.$store.commit('remove_selected_item', item)
          }
        })

        if (selectedItems.length) {
          this.$emit('select', {items: selectedItems}, mainSelectedItem) // done selecting items
        }
      }
    },
    goBack: function() {
      this.$emit('back') // go back to the previous step (ignore changes to item selection)
    },
    changeQuantity: function(item, quantity) {
      this.rmaQuantities[item.id] = quantity
      this.updateSelectAll()

      if (this.isSessionItem(item)) {
        this.updateLinkedRMAQuantities()
      }
    },
    onRowClicked: function(item, index, event) {
      // a row in the table was clicked - toggle the state of the item
      this.toggleItem(item, (this.rmaQuantities[item.id] === 0))
    },
    isItemChecked: function(item) {
      if (this.rmaQuantities[item.id] > 0) {
        return true
      }

      return !this.isLinkedItem(item) && !this.canToggleItem(item)
    },
    isLinkedItem: function(item) {
      return this.linkedItems.some(value => value.id === item.id)
    },
    isSessionItem: function(item) {
      return item && this.session && this.session.selected_item && item.id === this.session.selected_item.id
    },
    canToggleItem: function(item) {
      if (this.isLinkedItem(item) || this.isSessionItem(item)) {
        return false
      }

      return (!this.isOnHold || !item.isAddOn || !this.areAllMainItemsSelected())
    },
    toggleItem: function(item, checked) {
      if (checked) {
        this.rmaQuantities[item.id] = item.quantity // set the item to its default quantity
        this.updateSelectedItemsForCancel(true)
      } else if (!this.isSessionItem(item)) {
        this.updateSelectedItemsForCancel(false)
        this.rmaQuantities[item.id] = 0 // clear the item's quantity
      }

      if (this.isSessionItem(item)) {
        this.updateLinkedRMAQuantities()
      }

      this.updateSelectAll()
    },
    toggleAll: function(checked) {
      if (checked) {
        this.items.forEach(item => {
          if (this.rmaQuantities[item.id] === 0) {
            this.rmaQuantities[item.id] = item.quantity // set the item to its default quantity if it wasn't selected
          }
        })
      } else {
        this.items.forEach(item => {
          if (!this.isSessionItem(item)) {
            this.rmaQuantities[item.id] = 0 // clear the item's quantity
          }
        })
      }

      this.updateLinkedRMAQuantities()
      this.updateSelectAll()
    },
    getImageUrl: function(item) {
      return getItemImageUrl(item, 'small')
    },
    getSelectionCount: function() {
      let selectionCount = 0

      this.items.forEach(item => {
        if (this.rmaQuantities[item.id] > 0) {
          selectionCount++
        }
      })

      return selectionCount
    },
    updateSelectAll: function() {
      const selectionCount = this.getSelectionCount()

      // update the select all checkbox
      if (selectionCount === 0) {
        this.allSelected = false
        this.indeterminate = false
      } else if (selectionCount === this.items.length) {
        this.allSelected = true
        this.indeterminate = false
      } else {
        this.allSelected = false
        this.indeterminate = true
      }
    },
    updateLinkedRMAQuantities: function() {
      if (this.session.selected_item) {
        const selectedItemRMAQuantity = this.rmaQuantities[this.session.selected_item.id]
        let rmaQuantities = this.rmaQuantities

        this.linkedItems.forEach(item => {
          // calculate the rma quantity for the linked item (add an epsilon value before the floor function)
          const linkedQuantityRatio = item.quantity / this.session.selected_item.quantity

          rmaQuantities[item.id] = Math.floor((linkedQuantityRatio * selectedItemRMAQuantity) + 0.00000001)
        })

        this.rmaQuantities = Object.assign({}, rmaQuantities)
      }
    },
    isMainItem: function(item) {
      return item.campaign_product.product_type === ProductType.Offer &&
        item.campaign_product.process_type === ProcessType.Sale
    },
    isAddonItem: function(item) {
      if (item.campaign_product.process_type !== ProcessType.Sale) {
        return true
      }

      return (item.campaign_product.product_type === ProductType.Upsale) && (this.session.campaign.auto_cancel_upsells)
    },
    areAllMainItemsSelected: function() {
      let areAllMainItemsSelected = true
      let hasMainItem = false

      // check if all our main items are selected
      this.items.forEach(item => {
        if (this.isMainItem(item)) {
          hasMainItem = true

          if (this.rmaQuantities[item.id] === 0) {
            areAllMainItemsSelected = false
          }
        }
      })

      this.allMainItemsSelected = hasMainItem && areAllMainItemsSelected
      return this.allMainItemsSelected
    },
    updateSelectedItemsForCancel: function(selected) {
      // if all the main items are selected, auto select any warranties and the upsells too (if configured)
      if (this.isOnHold && this.areAllMainItemsSelected()) {
        // clear all the add on item selections (they will still appear selected and get cancelled by the backend)
        this.items.forEach(item => {
          if (this.isAddonItem(item)) {
            if (selected) {
              this.rmaQuantities[item.id] = item.quantity
            } else {
              if (!this.isSessionItem(item)) {
                this.rmaQuantities[item.id] = 0
              }
            }
          }
        })
      }
    }
  },
  created() {
    this.$store.commit('busy')
    let linkedProductIdMap = {}
    const params = this.rebill ? {latest_cycle: true,
      status__in: ItemStatus.RecycleBillingFailed.toString() + ',' + ItemStatus.RecycleFailedHold.toString()}
      : (this.session && this.session.selected_item ? {order: this.session.selected_item.order.id} : {})
    let queries = [axios.get('/order_items/', {params: params})]

    if (this.session.selected_item) {
      queries.push(axios.get(
        '/campaign_products/' + this.session.selected_item.campaign_product.id.toString() + '/'))
    }

    axios.all(queries).then(results => {
      const result = results[0]
      const campaignProduct = (results.length > 1) ? results[1].data : null
      let invalidReturn = false
      let showQuantitySelection = false

      console.log(result)

      // get the current selected item's linked products
      if (campaignProduct && campaignProduct.linked_products) {
        campaignProduct.linked_products.forEach((product, index) => {
          linkedProductIdMap[product.id] = index
        })
      }

      if (this.rebill) {
        result.data.results.forEach(item => {
          this.items.push(item)
          this.rmaQuantities[item.id] = item.quantity // default to selected
          this.title = 'Confirm Your Subscriptions'
          this.subtitle = 'Please select your subscriptions to remain active'
        })
      } else {
        // select the current selected item by default
        this.items.push(this.session.selected_item)
        this.rmaQuantities[this.session.selected_item.id] = 0 // default to not selected

        // get current fulfillment status
        this.isOnHold = (this.session.selected_item.fulfillment_status === FulfillmentStatus.Hold) ||
          (this.session.selected_item.fulfillment_status === FulfillmentStatus.Frozen) ||
          (this.session.selected_item.status === ItemStatus.Pending)

        if (!this.isOnHold) {
          if (this.session.selected_item.fulfillment_status === FulfillmentStatus.None) {
            invalidReturn = true
            result.data.results.forEach(item => {
              if (
                item.fulfillment_status === FulfillmentStatus.Hold ||
                item.fulfillment_status === FulfillmentStatus.Frozen
              ) {
                this.isOnHold = true
                invalidReturn = false
              }
            })
          }
        }

        if (invalidReturn) {
          // invalid return, so just select the default item and move on so we can fail gracefully
          this.$store.commit('ready')
          this.rmaQuantities[this.session.selected_item.id] = this.session.selected_item.quantity
          this.done()
          return
        }

        showQuantitySelection = !this.isOnHold && (this.session.selected_item.quantity > 1)
        const isSelectedMainItem = this.isMainItem(this.session.selected_item)
        const isSelectedUpsellItem = this.session.selected_item.campaign_product.product_type === ProductType.Upsale

        // get list of the other items within the order that can be cancelled/returned
        result.data.results.forEach(item => {
          if ((item.id !== this.session.selected_item.id) && (item.fulfillment_status !== FulfillmentStatus.NextCycle)) {
            if (item.campaign_product.id in linkedProductIdMap) {
              if (this.isOnHold) {
                if (item.can_cancel) {
                  this.linkedItems.push(item)
                }
              } else {
                if (item.can_return || item.can_exchange) {
                  this.linkedItems.push(item)
                }
              }
            } else if (this.isOnHold) {
              if (item.can_cancel) {
                const isUpsellItem = item.campaign_product.product_type === ProductType.Upsale
                const showSetting = this.session.cancel_items_selection

                if ((showSetting === CancelItemsSelection.ShowAll) ||
                  ((showSetting === CancelItemsSelection.UpsellsOnly) && isUpsellItem) ||
                  ((showSetting === CancelItemsSelection.UpsellsOnlyIfUpsell) && (
                    isSelectedMainItem || (isSelectedUpsellItem && isUpsellItem)
                  ))) {
                  this.items.push(item)
                  this.rmaQuantities[item.id] = 0 // default to not selected
                }
              }
            } else {
              if (item.can_return || item.can_exchange) {
                const isUpsellItem = item.campaign_product.product_type === ProductType.Upsale
                const showSetting = this.session.return_items_selection

                if ((showSetting === CancelItemsSelection.ShowAll) ||
                  ((showSetting === CancelItemsSelection.UpsellsOnly) && isUpsellItem) ||
                  ((showSetting === CancelItemsSelection.UpsellsOnlyIfUpsell) && (
                    isSelectedMainItem || (isSelectedUpsellItem && isUpsellItem)
                  ))) {
                  this.items.push(item)
                  this.rmaQuantities[item.id] = 0 // default to not selected

                  if (item.quantity > 1) {
                    showQuantitySelection = true // show quantity selections if we have a multi quantity item
                  }
                }
              }
            }
          }
        })

        if (this.isOnHold) {
          this.title = 'Select Items to Cancel'
          this.subtitle = 'Please select the items from your order you would like to cancel'
        } else {
          this.title = 'Select Items to Return'
          this.subtitle = 'Please select the items from your order you would like to return'
        }

        if (showQuantitySelection) {
          this.itemDataFields.push({key: 'selectedQuantity', label: 'Quantity', tdClass: 'item-quantity'})
        }

        // initialize the set of default selected items
        if (this.defaults && ('items' in this.defaults) && this.defaults.items.length) {
          this.defaults.items.forEach(item => {
            this.rmaQuantities[item.id] = item.quantity
          })
        } else {
          // select the current selected item by default
          this.rmaQuantities[this.session.selected_item.id] = this.session.selected_item.quantity

          // select other selected items that are part of the same order by default
          for (let i = this.startIndex; i < this.selectedItems.length; i++) {
            const item = this.selectedItems[i]

            if (item.id in this.rmaQuantities) {
              this.rmaQuantities[item.id] = item.quantity
            }
          }
        }

        // sort the linked items
        this.linkedItems.sort(function(a, b) {
          return linkedProductIdMap[a.campaign_product.id] - linkedProductIdMap[b.campaign_product.id]
        })
      }

      this.updateLinkedRMAQuantities()
      this.updateSelectAll()
      this.updateSelectedItemsForCancel(true)
      this.$store.commit('ready')

      if (this.session.auto_select_single_item && (this.items.length === 1) && !showQuantitySelection) {
        const item = this.items[0]
        this.rmaQuantities[item.id] = item.quantity // make sure our item is selected
        this.done() // if auto selecting single item and that's all we have, select it and move on
      }
    }, error => {
      console.error(error)
      this.$store.commit('critical_error', error)
      this.$store.commit('ready')
    })
  }
}
</script>

<style scoped>
  .stroke{
    border: 2px solid;
  }

  .order-pic {
    float: left;
    padding-left: 0;
    max-width: 50px;
  }

  @media only screen and (min-width: 415px) {
    .order-pic {
      max-width: 60px;
    }
  }

  @media only screen and (min-width: 768px) {
    .order-pic {
      max-width: auto;
    }
  }

</style>
